/* Copyright 2013 The MathWorks, Inc. */

/**
 * This defines a mapping between the type of control and the properties associated with it.
 * A property can be marked as required and a default value can also be assigned to it.
 */

define([
        "dojo/_base/lang",
        /*
         container properties
         */

        "MW/toolstrip/hashes/componentproperties/containers/ToolstripProperties",
        "MW/toolstrip/hashes/componentproperties/containers/QABProperties",
        "MW/toolstrip/hashes/componentproperties/containers/QAGroupProperties",
        "MW/toolstrip/hashes/componentproperties/containers/TabGroupProperties",
        "MW/toolstrip/hashes/componentproperties/containers/TabProperties",
        "MW/toolstrip/hashes/componentproperties/containers/ColumnProperties",
        "MW/toolstrip/hashes/componentproperties/containers/SectionProperties",
        "MW/toolstrip/hashes/componentproperties/containers/PanelProperties",
        "MW/toolstrip/hashes/componentproperties/containers/FooterProperties",
        "MW/toolstrip/hashes/componentproperties/containers/FooterCellProperties",

        /*
         Button properties
         */

        "MW/toolstrip/hashes/componentproperties/controls/PushButtonProperties",
        "MW/toolstrip/hashes/componentproperties/controls/ToggleButtonProperties",
        "MW/toolstrip/hashes/componentproperties/controls/DropDownButtonProperties",
        "MW/toolstrip/hashes/componentproperties/controls/SplitButtonProperties",
        "MW/toolstrip/hashes/componentproperties/controls/ToggleSplitButtonProperties",
        "MW/toolstrip/hashes/componentproperties/controls/ColorPickerButtonProperties",
        "MW/toolstrip/hashes/componentproperties/controls/GridPickerButtonProperties",


        /*
         QAB button properties
         */

        "MW/toolstrip/hashes/componentproperties/controls/QABPushButtonProperties",
        "MW/toolstrip/hashes/componentproperties/controls/QABDropDownButtonProperties",
        "MW/toolstrip/hashes/componentproperties/controls/QABFloatingPaneDockProperties",
        "MW/toolstrip/hashes/componentproperties/controls/QABSplitButtonProperties",
        "MW/toolstrip/hashes/componentproperties/controls/QABToggleButtonProperties",
        "MW/toolstrip/hashes/componentproperties/controls/QABToggleSplitButtonProperties",

        /*
         select properties
         */

        "MW/toolstrip/hashes/componentproperties/controls/ComboBoxProperties",
        "MW/toolstrip/hashes/componentproperties/controls/ListProperties",

        /*
         Popup List properties
         */
        "MW/toolstrip/hashes/componentproperties/controls/PopupListProperties",
        "MW/toolstrip/hashes/componentproperties/controls/PopupListPanelProperties",
        "MW/toolstrip/hashes/componentproperties/controls/PopupListHeaderProperties",
        "MW/toolstrip/hashes/componentproperties/controls/PopupListSeparatorProperties",

        /*
         other properties
         */

        "MW/toolstrip/hashes/componentproperties/controls/TextAreaProperties",
        "MW/toolstrip/hashes/componentproperties/controls/TextFieldProperties",
        "MW/toolstrip/hashes/componentproperties/controls/HorizontalSliderProperties",
        "MW/toolstrip/hashes/componentproperties/controls/SpinnerProperties",
        "MW/toolstrip/hashes/componentproperties/controls/RadioButtonProperties",
        "MW/toolstrip/hashes/componentproperties/controls/CheckBoxProperties",
        "MW/toolstrip/hashes/componentproperties/controls/LabelProperties",
        "MW/toolstrip/hashes/componentproperties/controls/EmptyControlProperties",
        "MW/toolstrip/hashes/componentproperties/controls/MenuBarWrapperProperties",
        "MW/toolstrip/hashes/componentproperties/controls/ToolBarWrapperProperties",

        /*
         Gallery properties
         */

        "MW/toolstrip/hashes/componentproperties/controls/GalleryProperties",
        "MW/toolstrip/hashes/componentproperties/controls/GalleryPopupProperties",
        "MW/toolstrip/hashes/componentproperties/controls/GalleryPanelProperties",
        "MW/toolstrip/hashes/componentproperties/controls/GalleryCategoryProperties",
        "MW/toolstrip/hashes/componentproperties/controls/GalleryFavoriteCategoryProperties",
        "MW/toolstrip/hashes/componentproperties/controls/GalleryItemProperties",
        "MW/toolstrip/hashes/componentproperties/controls/ToggleGalleryItemProperties",

        /*
         List Item properties
         */
        "MW/toolstrip/hashes/componentproperties/controls/ListItemProperties",
        "MW/toolstrip/hashes/componentproperties/controls/ListItemWithCheckBoxProperties",
        "MW/toolstrip/hashes/componentproperties/controls/ListItemWithRadioButtonProperties",
        "MW/toolstrip/hashes/componentproperties/controls/ListItemWithTextFieldProperties",
        "MW/toolstrip/hashes/componentproperties/controls/ListItemWithPopupProperties",

        /*
         Status Bar properties
         */
        "MW/statusbar/properties/StatusBarProperties",
        "MW/statusbar/properties/StatusGroupProperties",
        "MW/statusbar/properties/StatusLabelProperties",
        "MW/statusbar/properties/StatusProgressBarProperties",
        "MW/statusbar/properties/StatusPushButtonProperties",
        "MW/statusbar/properties/StatusTextFieldProperties",
        "MW/statusbar/properties/StatusToggleButtonProperties"

    ],
    function (lang, /*
     ContainerProperties
     */
              ToolstripProperties, QABProperties, QAGroupProperties, TabGroupProperties,
              TabProperties,
              ColumnProperties, SectionProperties, PanelProperties, FooterProperties,
              FooterCellProperties, /*
               Button Properties
               */
              PushButtonProperties, ToggleButtonProperties, DropDownButtonProperties,
              SplitButtonProperties,
              ToggleSplitButtonProperties,
              ColorPickerButtonProperties, GridPickerButtonProperties,/*
               QAB Button Properties
               */
              QABPushButtonProperties, QABDropDownButtonProperties, QABFloatingPaneDockProperties,
              QABSplitButtonProperties,
              QABToggleButtonProperties,
              QABToggleSplitButtonProperties, /*
               Select Properties
               */
              ComboBoxProperties, ListProperties, /*
               PopupList Properties
               */
              PopupListProperties, PopupListPanelProperties, PopupListHeaderProperties,
              PopupListSeparatorProperties, /*
               Other Properties
               */
              TextAreaProperties, TextFieldProperties, HorizontalSliderProperties,
              SpinnerProperties,
              RadioButtonProperties, CheckBoxProperties, LabelProperties, EmptyControlProperties,
              MenuBarWrapperProperties, ToolBarWrapperProperties, /*
               Gallery Properties
               */
              GalleryProperties, GalleryPopupProperties, GalleryPanelProperties, GalleryCategoryProperties,
              GalleryFavoriteCategoryProperties,
              GalleryItemProperties, ToggleGalleryItemProperties, /*
               List Item Properties
               */
              ListItemProperties, ListItemWithCheckBoxProperties, ListItemWithRadioButtonProperties,
              ListItemWithTextFieldProperties, ListItemWithPopupProperties, /*
               Status Bar properties
               */
              StatusBarProperties, StatusGroupProperties, StatusLabelProperties, StatusProgressBarProperties,
              StatusPushButtonProperties, StatusTextFieldProperties, StatusToggleButtonProperties) {

        var hash = {}, args = Array.prototype.slice.call(arguments);

        args.forEach(function (arg, i) {
            // Skip the first argument since that is the dojo/_base/lang
            if (i > 0) {
                lang.mixin(hash, arg);
            }
        });

        return hash;
    });
